import {
	BOOKING_LIST_GET_LIST,
	BOOKING_LIST_GET_LIST_SUCCESS,
	BOOKING_LIST_GET_LIST_ERROR,
	BOOKING_LIST_GET_LIST_WITH_FILTER	
} from '../actions';

const INIT_STATE = {
	allbookings:null,	
	bookings: null,	
    loading: false	
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case BOOKING_LIST_GET_LIST:
			return { ...state, loading: false };

        case BOOKING_LIST_GET_LIST_SUCCESS:  
        //console.log(action.payload)       ; 
			return { ...state, loading: true, allbookings:action.payload.bookings, bookings: action.payload.bookings };

		case BOOKING_LIST_GET_LIST_ERROR:
			return { ...state, loading: true, error: action.payload };
			default: return { ...state };
			
		case BOOKING_LIST_GET_LIST_WITH_FILTER:
			console.log(action.payload);
			if (action.payload.startDate === '' || action.payload.endDate === '') {
				return { ...state, loading: true, chats: state.allchats, filter: null };
			} else {			

				const filteredItems = state.allchats.filter((item) =>
				//console.log(new Date(item["chatDateTime"]).getTime())
				new Date( item["chatDateTime"]).getTime() >= new Date(action.payload.startDate).getTime() && 
				new Date( item["chatDateTime"]).getTime() <= new Date(action.payload.endDate).getTime()
				&& (item["hotel"]===action.payload.hotel || "-1"===action.payload.hotel)
				);
					//item[action.payload.column] === action.payload.value);
				return {
					...state, loading: true, chats: filteredItems, filter: {
						startDate: action.payload.startDate,
						endDate: action.payload.endDate
					}
				}
			}
	}
}
